import {
    FETCH_APPLICATION_FAILURE,
    FETCH_APPLICATION_REQUEST,
    FETCH_APPLICATION_SUCCESS,
    UPDATE_APPLICATION_FAILURE,
    UPDATE_APPLICATION_REQUEST,
    UPDATE_APPLICATION_SUCCESS,
} from '../../actions/admin/application.action';
import { sortArray } from '../../utils/common';

const formatDate = (date) => date.toString().replace(/GMT.*/g, '');

const initialState = {
    applicationData: [], loading: false, error: '',
};

const ApplicationReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_APPLICATION_REQUEST:
            return { ...state, loading: true, error: null };
        case FETCH_APPLICATION_SUCCESS:
            return {
                ...state,
                updatedDateTime: formatDate(new Date()),
                loading: false,
                applicationData: sortArray(action.payload,'appName'),
            };
        case FETCH_APPLICATION_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case UPDATE_APPLICATION_REQUEST:
            return { ...state, loading: true, error: null };

        case UPDATE_APPLICATION_SUCCESS:
            if (!action.payload?.id) return state;


            const idx = state.applicationData.findIndex(f => f.id === action.payload.id);

            state.applicationData[idx] = { ...action.payload };


            // const data_add = action.payload?.id ? [...state.applicationData.filter(item => item.id !== action.payload.id), { ...action.payload }] : [...state.applicationData];
            return {
                ...state,
                updatedDateTime: formatDate(new Date()),
                loading: false,
                applicationData: [...sortArray(state.applicationData,'appName')],
            };
        case UPDATE_APPLICATION_FAILURE:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};

export default ApplicationReducer;